import activityLogServices from '../services/activityLogServices.js';

import dataModel from '../models/DataModel.js';
import DAO from './DAO.js';

//only used for the retrieval of activities and sub types in order to log event histories
//singleton data that is normalized to store here and not by regular patterns
export default class ActivitySubTypesDAO extends DAO {

  setActivitySubTypesAction(activity_sub_types) {
    return {
      type: 'ACTIVITY_SUB_TYPES_SET',
      activity_sub_types,
    };
  }

  clearActivitySubTypesAction() {
    return {
      type: 'ACTIVITY_SUB_TYPES_CLEAR',
    };
  }

  findActivitySubType(extension, activityId) {
    let foundActivitySubType;
    foundActivitySubType = Object.values(this.stateTree.activity_sub_types).find(sub_type => {
      return sub_type.name.includes(extension) && sub_type.activity_id == activityId;
    });

    if (!foundActivitySubType) {
      foundActivitySubType = Object.values(this.stateTree.activity_sub_types).find(sub_type => {
        return sub_type.name == 'Other' && sub_type.activity_id == activityId;
      });
    }

    return foundActivitySubType;
  }

  setActivitySubTypes(activity_sub_types) {
    this.store.dispatch(this.setActivitySubTypesAction(activity_sub_types));
  }

  clearActivitySubTypes() {
    this.store.dispatch(this.clearActivitySubTypesAction());
  }

  getActivitySubType(extension, activityId) {
    const currentActivitySubType = this.findActivitySubType(extension, activityId);

    // If not online don't fetch
    if (dataModel.isOffline) {
      return new Promise(resolve => {
        if (currentActivitySubType && currentActivitySubType._recordState) {
          currentActivitySubType._recordState.pending = false;
          currentActivitySubType._recordState.synced = true;
        }
        return resolve(currentActivitySubType);
      });
    }

    if (!currentActivitySubType) {
      return activityLogServices.getActivitiesList().then(response => {
        let activities = {};
        let activity_sub_types = {};
        let foundActivitySubType;

        response.activities.forEach(activity => {
          activities[activity.id] = {
            id: activity.id,
            name: activity.name,
          };

          activity.activity_sub_types.forEach(sub_type => {
            activity_sub_types[sub_type.id] = {
              id: sub_type.id,
              name: sub_type.name,
              activity_id: activity.id,
            };

            if (
              sub_type.name.includes(extension) &&
              activity.id == activityId
            ) {
              foundActivitySubType = activity_sub_types[sub_type.id];
            }
          });
        });

        if (!foundActivitySubType) {
          foundActivitySubType = Object.values(activity_sub_types).find(sub_type => {
            return sub_type.name == 'Other' && sub_type.activity_id == activityId;
          });
        }

        dataModel.activitiesDAO.setActivities(activities);
        this.setActivitySubTypes(activity_sub_types);
        return foundActivitySubType;
      });

    } else {
      return Promise.resolve(currentActivitySubType);
    }
  }
}



// WEBPACK FOOTER //
// ./src/dao/ActivitySubTypesDAO.js